import { render, staticRenderFns } from "./ResaleListView.vue?vue&type=template&id=6b420837&scoped=true"
import script from "./ResaleListView.vue?vue&type=script&lang=js"
export * from "./ResaleListView.vue?vue&type=script&lang=js"
import style0 from "./ResaleListView.vue?vue&type=style&index=0&id=6b420837&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b420837",
  null
  
)

export default component.exports